import {routeHasChanged} from './route/actions';
import {history} from '../router/history';

export function historyListener(store) {
  history.listen((location) => store.dispatch(routeHasChanged(location)));
}



// WEBPACK FOOTER //
// ./src/state/historyListener.js